// extracted by mini-css-extract-plugin
export default {"modal":"EditMDXModal_modal__Vq3sp","buttons":"EditMDXModal_buttons__vbgTJ","titleRow":"EditMDXModal_titleRow__N0Zfa","previewTitleRow":"EditMDXModal_previewTitleRow__h7+QK"};